module.exports = __webpack_public_path__ + "static/media/bad.712f3d26.png";